import React, { useEffect } from "react";
import clsx from "clsx";
import "./SummaryConfig.css";
import ConfigureLuvers from "./ConfigureLuvers";
import {
  TextField,
  createMuiTheme,
  InputAdornment,
  MuiThemeProvider,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { green } from "@material-ui/core/colors";

const ColorButton = withStyles((theme) => ({
  root: {
    color: "white",
    minWidth: "20px",
    padding: "2px 6px",
    marginLeft: "4px",
    backgroundColor: "#4FBE19",
    "&:hover": {
      backgroundColor: green[900],
    },
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxWidth: "300px",
  },
}));

const theme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      root: {
        // "&$focused": {
        //   color: "#C34720",
        //   fontWeight: "bold",
        // },
      },
      focused: {},
    },
    MuiInputBase: {
      root: {
        "&$focused": {
          borderColor: "#C34720",
        },
      },
    },
  },
});

function SummaryConfig(props: any) {
  const [open, setOpen] = React.useState({} as any);
  const handleOpen = (n: number) => {
    open[n] = true;
    setOpen({ ...open });
  };

  const handleClose = (n: number) => {
    open[n] = false;
    setOpen({ ...open });
  };

  const classes = useStyles();

  // Set count of top luvers dependence on lenght
  useEffect(() => {
    let count;
    if (props.konfigured["luvers"] === "BEZ_OCZEK") {
      count = 0;
    } else {
      const recomendedDistanceBetween = 50;
      count = Math.floor(
        props.konfigured["length"] / recomendedDistanceBetween
      );
    }

    props.setLuversCount(count, "top_luvers_count");
  }, [props.konfigured["length"]]);

  // Set count of left/right luvers dependence on width

  useEffect(() => {
    let count;
    if (props.konfigured["luvers"] === "BEZ_OCZEK") {
      count = 0;
    } else {
      const recomendedDistanceBetween = 50;
      count = Math.floor(props.konfigured["width"] / recomendedDistanceBetween);
    }
    props.setLuversCount(count, "left_luvers_count");
    props.setLuversCount(count, "right_luvers_count");
  }, [props.konfigured["width"]]);

  return (
    <div className="summary-config">
      <div
        onClick={() => {
          handleOpen(1);
        }}
        className="summary-mobile-link"
      >
        Rozmiar{" "}
        <ColorButton
          onClick={() => {
            handleOpen(1);
          }}
        >
          <i className="icofont-ui-edit"></i>
        </ColorButton>
      </div>
      <div
        onClick={() => {
          handleOpen(2);
        }}
        className="summary-mobile-link"
      >
        Okno
        <ColorButton>
          <i className="icofont-ui-edit"></i>
        </ColorButton>
      </div>
      <div
        onClick={() => {
          handleOpen(3);
        }}
        className="summary-mobile-link"
      >
        Oczka
        <ColorButton>
          <i className="icofont-ui-edit"></i>
        </ColorButton>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open[1]}
        onClose={() => {
          handleClose(1);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open[1]}>
          <div className={classes.paper}>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <TextField
                  label="Szerokość"
                  id="standard-start-adornment"
                  type="number"
                  name="width"
                  value={props.konfigured.width}
                  onChange={(e) => props.onSelectChange(e)}
                  className={clsx(classes.textField)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Cm</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="length"
                  label="Długość"
                  id="standard-start-adornment"
                  type="number"
                  value={props.konfigured.length}
                  onChange={(e) => props.onSelectChange(e)}
                  className={clsx(classes.textField)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Cm</InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open[2]}
        onClose={() => {
          handleClose(2);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open[2]}>
          <div className={classes.paper}>
            {props.konfigured["window"] !== "bez_okna" ? (
              <div>
                {" "}
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextField
                      label="Szerokość"
                      id="standard-start-adornment"
                      type="number"
                      name="window_width"
                      value={props.konfigured["window_width"]}
                      onChange={(e) => props.onSelectChange(e)}
                      className={clsx(classes.textField)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Cm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="window_length"
                      label="Długość"
                      id="standard-start-adornment"
                      type="number"
                      value={props.konfigured["window_length"]}
                      onChange={(e) => props.onSelectChange(e)}
                      className={clsx(classes.textField)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Cm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Szczyt"
                      id="standard-start-adornment"
                      type="number"
                      value={props.konfigured["top_window_distace"]}
                      name="top_window_distace"
                      onChange={(e) => props.onSelectChange(e)}
                      className={clsx(classes.textField)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Cm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Prawo"
                      id="standard-start-adornment"
                      type="number"
                      value={props.konfigured["right_window_distace"]}
                      name="right_window_distace"
                      onChange={(e) => props.onSelectChange(e)}
                      className={clsx(classes.textField)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Cm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Lewo"
                      id="standard-start-adornment"
                      type="number"
                      value={props.konfigured["left_window_distace"]}
                      name="left_window_distace"
                      onChange={(e) => props.onSelectChange(e)}
                      className={clsx(classes.textField)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Cm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      label="Spód"
                      id="standard-start-adornment"
                      type="number"
                      value={props.konfigured["bottom_window_distace"]}
                      name="bottom_window_distace"
                      onChange={(e) => props.onSelectChange(e)}
                      className={clsx(classes.textField)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Cm</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            ) : (
              ""
            )}
          </div>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open[3]}
        onClose={() => {
          handleClose(3);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open[3]}>
          <div className={classes.paper}>
            <MuiThemeProvider theme={theme}>
              {props.konfigured["luvers"] !== "BEZ_OCZEK" ? (
                <ConfigureLuvers
                  luverSelects={props.luverSelects}
                  konfigured={props.konfigured}
                  onSelectChange={props.onSelectChange}
                ></ConfigureLuvers>
              ) : (
                ""
              )}
            </MuiThemeProvider>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default SummaryConfig;
